import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { useContactForm } from '../hooks/useContactForm';
import { ContactForm } from './ContactForm';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_kober-energy/artifacts/vys7c9cr_3.png";

export default function ContactModal({ open, onClose, text, lang = 'EN' }) {
  const formProps = useContactForm({ text, onSuccess: onClose, lang });

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent data-testid="contact-modal" className="max-w-lg p-0 border-0 bg-transparent shadow-none overflow-hidden">
        <div className="bg-[#0d0d0d] border border-white/12 p-8">
          <div className="flex items-center gap-3 mb-6">
            <img src={LOGO_URL} alt="KÖBER" className="h-28 w-auto opacity-90" />
          </div>
          <DialogHeader className="mb-6">
            <DialogTitle className="text-2xl font-medium text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>
              {text.title}
            </DialogTitle>
            <DialogDescription className="text-white/55 text-sm leading-relaxed mt-2">
              {text.subtitle}
            </DialogDescription>
          </DialogHeader>
          <ContactForm {...formProps} text={text} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
